import React from 'react';
import { Menu, X } from 'lucide-react';

const NavigationBar = ({ currentPage, setCurrentPage, mobileMenuOpen, setMobileMenuOpen, onAdminClick }) => {
  const menuItems = [
    { id: 'home', label: 'Beranda' },
    { id: 'program', label: 'Program Kelas' },
    { id: 'silabus', label: 'Silabus' },
    { id: 'schedule', label: 'Jadwal' },
    { id: 'careers', label: 'Karir' },
    { id: 'about', label: 'Tentang Kami' },
  ];

  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="bg-blue-50 border-b-2 border-blue-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 gap-12">
          {/* Logo */}
          <div
            className="flex items-center gap-2 cursor-pointer group transition-transform hover:scale-105"
            onClick={() => setCurrentPage('home')}
          >
            <img 
              src="/images/partnership/istnxveloctlogo.png" 
              alt="ISTN VeloCT Logo" 
              className="h-12 w-auto object-contain"
            />
            <div className="flex flex-col justify-center">
              <div className="text-xl font-display font-bold leading-tight">
                <span className="text-blue-800">AIXpert</span>
              </div>
              <div className="text-xs text-blue-500 font-medium">by VeloCT & ISTN</div>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`px-4 py-2 text-base font-medium transition-all border-b-2 ${
                  currentPage === item.id
                    ? 'text-blue-700 border-blue-700'
                    : 'text-blue-800 border-transparent hover:text-blue-600'
                }`}
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('program')}
              className="ml-4 bg-blue-700 text-blue-50 px-6 py-3 rounded-xl hover:bg-blue-800 transition-all shadow-md hover:shadow-lg font-semibold text-base"
            >
              Daftar Sekarang
            </button>
            <button
              onClick={onAdminClick}
              className="ml-2 text-blue-500 hover:text-blue-700 transition text-xl p-2"
              title="Admin Panel"
            >
              🔐
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              className="bg-blue-100 p-2 rounded-lg text-blue-800"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 pt-2 space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => { handleNavClick(item.id); setMobileMenuOpen(false); }}
                className={`block w-full text-left py-3 px-4 text-base font-medium border-l-4 transition-all ${
                  currentPage === item.id
                    ? 'bg-blue-50 text-blue-700 border-blue-700'
                    : 'text-blue-800 border-transparent hover:bg-blue-100'
                }`}
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => { handleNavClick('program'); setMobileMenuOpen(false); }}
              className="w-full bg-blue-700 text-blue-50 px-6 py-3 rounded-xl hover:bg-blue-800 mt-2 font-semibold text-base"
            >
              Daftar Sekarang
            </button>
            <button
              onClick={() => { onAdminClick(); setMobileMenuOpen(false); }}
              className="w-full text-left py-2 px-4 text-blue-500 hover:text-blue-700 text-base"
            >
              🔐 Admin Panel
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavigationBar;
